import React from "react";
import { useTheme } from "../contexts/ThemeContext";

export default function KretaraLogo({ size = 36, withText = true, light = false }) {
  const { theme } = useTheme();
  // light=true forces light-on-dark rendering (used on dark hero panels)
  const onDark = light || theme === "dark";

  const stroke = onDark ? "#F0EFF8" : "#1A1830";
  const textColor = onDark ? "#F0EFF8" : "#1A1830";
  const subColor = onDark ? "#AFA9EC" : "#534AB7";

  return (
    <div className="flex items-center gap-2" data-testid="kretara-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Kretara"
      >
        <line x1="22" y1="14" x2="22" y2="58" stroke={stroke} strokeWidth="6" strokeLinecap="round" />
        <line x1="22" y1="36" x2="44" y2="14" stroke={stroke} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="22" y1="36" x2="44" y2="58" stroke={stroke} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="44" cy="14" r="6.5" fill="#1D9E75" />
        <circle cx="44" cy="58" r="6.5" fill="#534AB7" />
      </svg>
      {withText && (
        <div className="leading-tight">
          <div
            className="font-bold tracking-tight"
            style={{ color: textColor, fontSize: size * 0.5, fontFamily: "Outfit, sans-serif" }}
          >
            Kretara<span style={{ color: subColor }}>.ai</span>
          </div>
          <div className="text-[9px] uppercase tracking-[0.18em]" style={{ color: subColor }}>
            Procurement Intelligence
          </div>
        </div>
      )}
    </div>
  );
}
